/**
 * The Courses link (user-guide videos), the same on every page header.
 *
 * It used to be only on the Home screen and the claims top bar, so it
 * vanished on the Matters list, Drawings and Specification pages and a
 * drafter could not tell when it would be there (Arthur, 3 Nov 2026).
 */
import React from 'react';
import { GraduationCap } from 'lucide-react';

interface Props {
  onOpenCourses?: () => void;
  /** Where it sits, so each page's link can be found by tests. */
  testId?: string;
}

export default function CoursesLink({ onOpenCourses, testId = 'courses-link' }: Props) {
  if (!onOpenCourses) return null;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onOpenCourses}
      title="User-guide videos"
      className="text-zinc-500 hover:text-zinc-900 transition-colors p-1.5 flex items-center gap-1 text-xs"
    >
      <GraduationCap size={16} /> Courses
    </button>
  );
}
